import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { string } from 'prop-types';

export const KitchenCollectionTitle = ({ name, brandName, className }) => {
  const brandText = brandName.includes('/staticImages/') ? '' : brandName;
  return (
    <Row className={`kitchen-collection__title ${className}`} data-testid="kitchen-collection-title">
      <Col flatten className="kitchen-collection__title--main">
        <h1 className="kitchen-collection__collection-name--medium">
          {name}
        </h1>
        <h2>
          <span>
            <a
              className="product-header__brand-name disabled-link"
              href=" "// TODO: Add Brand link once back-end gets set up for it
            >
              {brandText}
            </a>
          </span>
        </h2>
      </Col>
    </Row>
  );
};

KitchenCollectionTitle.displayName = 'KitchenCollectionTitle';

KitchenCollectionTitle.propTypes = {
  name: string.isRequired,
  brandName: string.isRequired,
  className: string
};

KitchenCollectionTitle.defaultProps = {
  className: 'kitchen-collection-title'
};